import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getBadge} from '../../../apis/badge/getBadge'

const useQueryBadge = (id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.badge.getBadgeDetail(id),
        queryFn: async () => {
            const {data, pageInfo} = await getBadge(id)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
        enabled: !!id,
    })

    return {data, refetch}
}

export default useQueryBadge
